<template>
	<div>
		<el-row :gutter="10">
			<!-- 左边 -->
			<el-col :xs="0" :sm="15" :md="15" :lg="15" :xl="15" :offset="2">
			  <div class="grid-content left">
				  <div class="position">
					<el-breadcrumb separator-class="el-icon-d-arrow-right">
					  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  <el-breadcrumb-item>散单需求</el-breadcrumb-item>
					</el-breadcrumb>  
				  </div>
				  <div class="search">
					<el-row :gutter="60">
						<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
						<el-select v-model="hangyeId" filterable clearable placeholder="请选择行业" @change="onHangYeChange" @clear="onClear">
							<el-option
							  v-for="item in hangyes"
							  :key="item.Id"
							  :label="item.name"
							  :value="item.name">
							</el-option>
						</el-select>
						</el-col>
						<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
						<el-select v-model="provinceId" filterable clearable placeholder="请选择省份" @change="onProvinceChange" @clear="onClear">
							<el-option
							  v-for="item in provinces"
							  :key="item.Id"
							  :label="item.name"
							  :value="item.name">
							</el-option>
						</el-select>
						</el-col>
						<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
						<el-select v-model="statussId" filterable clearable placeholder="请选择状态" @change="onStatusChange" @clear="onClear">
							<el-option
							  v-for="item in statuss"
							  :key="item.value"
							  :label="item.label"
							  :value="item.value">
							</el-option>
						</el-select>
						</el-col>
					</el-row>
					<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<div class="searchInput" style="width:100%">
							<el-input placeholder="请输入关键词" v-model="keywords" class="input-with-select" style="border-radius: 5px;width:100%;margin-top:10px;">
								<el-button type="primary" slot="append" icon="el-icon-search" style="background-color: #409EFF;color: #fff;height: 40px;width:100px;margin-right:-21px;" class="searchBtn" @click="search(keywords)">搜索</el-button>
							</el-input>
						</div>
				    </el-col>
				  </div>
				  <div class="contentList">
					  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						    <el-table
						      :data="tableData"
						      border
						      style="width: 100%">
						      <el-table-column
								header-align="center"
						        prop="title"
						        label="标题">
								<template slot-scope="props">
									<el-link type="primary" @click="handle(props.row.Id)" :underline="false">{{props.row.province_id}} | {{props.row.title.slice(0,36)}}</el-link>
								</template>
						      </el-table-column>
						      <el-table-column
								align="center"
						        prop="hangye_id"
						        label="行业"
						        width="100">
								<template slot-scope="props">
									{{props.row.hangye}}
								</template>
						      </el-table-column>
						      <el-table-column
								align="center"
						        prop="starttime"
						        label="报名开始时间"
								width="110">
								<template slot-scope="props">
									{{$utils.timestampToTimes(props.row.starttime*1000)}}
								</template>
						      </el-table-column>
							  <el-table-column
								align="center"
							    prop="endtime"
							    label="报名截止时间"
							    width="110">
								<template slot-scope="props">
									{{$utils.timestampToTimes(props.row.endtime*1000)}}
								</template>
							  </el-table-column>
							  <el-table-column
								align="center"
							    prop="status"
								width="110"
							    label="状态">
								<template slot-scope="props">
									<span class="red" v-if="props.row.status == 4">{{status(props.row.status)}}</span>
									<span class="blue" v-else-if="props.row.status == 2">{{status(props.row.status)}}</span>
									<span v-else>{{status(props.row.status)}}</span>
								</template>
							  </el-table-column>
						    </el-table>
							<div class="pagination">
								<el-pagination
								  :background="true"
								  :pager-count="pagerCount"
								  :page-size = "pageSize"
								  :page-sizes="[5,10,20]"
								  :current-page = "currentPage"
								  @current-change="currentChange"
								  @size-change="handleSizeChange"
								  prev-text ="上一页"
								  next-text = "下一页"
								  layout="prev, pager, next"
								  :total="total">
								</el-pagination>
							</div>
					</el-col>
				  </div>
			  </div>
			</el-col>
			<!-- 右边 -->
			<el-col :xs="0" :sm="5" :md="5" :lg="5" :xl="5">
				<div class="grid-content first">
					<el-carousel :interval="6000" arrow="never">
						<el-carousel-item v-for="item in bannerTop" :key="item.Id">
							<el-image :src="domain + item.image" fit='fill' style='width:100%;height:100%'></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="grid-content second">
					<div class="listHeader">
						采购中心
					</div>
					<el-card class="box-card">
					  <div v-for="o in caigoulist.slice(0,4)" :key="o.Id" class="text item" @click="handle(o.Id)">
						{{o.title.substring(0,18)}}
					  </div>
					</el-card>  
				</div>
				<div class="grid-content third">
					<el-carousel :interval="5000" arrow="never">
						<el-carousel-item v-for="item in bannerMiddle" :key="item.Id">
							<el-image :src="domain + item.image" fit='fill' style='width:100%;height:100%'></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="grid-content four">
					<div class="listHeader">
						散单需求
					</div>
					<el-card class="box-card">
					  <div v-for="o in sandanlist" :key="o.Id" class="text item" @click="handle(o.Id)">
						{{o.title.substring(0,18)}}
					  </div>
					</el-card>    
				</div>
			</el-col>
		</el-row>
		<!-- 手机端 -->
		<el-row>
			<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
				<div class="search">
					<el-row :gutter="10">
						<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
						<el-select v-model="hangyeId" filterable clearable placeholder="行业" @change="onHangYeChange" @clear="onClear">
							<el-option
							  v-for="item in hangyes"
							  :key="item.Id"
							  :label="item.name"
							  :value="item.name">
							</el-option>
						</el-select>
						</el-col>
						<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
						<el-select v-model="provinceId" filterable clearable placeholder="省份" @change="onProvinceChange" @clear="onClear">
							<el-option
							  v-for="item in provinces"
							  :key="item.Id"
							  :label="item.name"
							  :value="item.name">
							</el-option>
						</el-select>
						</el-col>
						<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
						<el-select v-model="statussId" filterable clearable placeholder="状态" @change="onStatusChange" @clear="onClear">
							<el-option
							  v-for="item in statuss"
							  :key="item.value"
							  :label="item.label"
							  :value="item.value">
							</el-option>
						</el-select>
						</el-col>
					</el-row>
					<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<div class="searchInput" style="width:100%">
							<el-input placeholder="请输入关键词" v-model="keywords" class="input-with-select" style="border-radius: 5px;width:100%;margin-top:10px;">
								<el-button type="primary" slot="append" icon="el-icon-search" style="background-color: #409EFF;color: #fff;height: 40px;width:100px;margin-right:-21px;" class="searchBtn" @click="search(keywords)" >搜索</el-button>
							</el-input>
						</div>
				  </el-col>
				</div>
			</el-col>
			<div class="contentList">
			  <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0" style="margin-top: 20px;">
					<el-table
					  :data="tableData"
					  border
					  :show-header="false"
					  style="width: 100%">
					  <el-table-column
						header-align="center"
						prop="title"
						label="标题"
						>
						<template slot-scope="props">
							<el-link type="primary" @click="handle(props.row.Id)" :underline="false">{{props.row.title}}</el-link>
							<div>
								<i class="el-icon-location-outline"></i>{{props.row.province_id}}
								<i class="el-icon-price-tag" style="padding-left: 5px;"></i>{{props.row.hangye}}
								<i class="el-icon-time" style="padding-left: 5px;"></i>{{$utils.timestampToTimes(props.row.endtime*1000)}}
							</div>
							<div>
								项目状态：									
									<span class="red" v-if="props.row.status == 4">{{status(props.row.status)}}</span>
									<span class="blue" v-else-if="props.row.status == 2">{{status(props.row.status)}}</span>
									<span v-else>{{status(props.row.status)}}</span>
							</div>
						</template>
					  </el-table-column>
					</el-table>
					<div class="pagination" style="margin-bottom:30px">
						<el-pagination
						  :background="true"
						  :pager-count="pagerCount"
						  :page-size = "pageSize"
						  :current-page = "currentPage"
						  @current-change="currentChange"
						  @size-change="handleSizeChange"
						  prev-text ="上一页"
						  next-text = "下一页"
						  layout="prev, pager, next"
						  :total="total">
						</el-pagination>

					</div>
					<!-- 分页器 -->
					
			</el-col>
			</div>
		</el-row>
	</div>
</template>

<script>
export default {
	name:'list',
	metaInfo() {
	  return {
		title: this.metaName,
		meta: [
		  { charset: "utf-8" },
		  { name: "keywords", content: this.metaKeywords },
		  { name: "description", content: this.metaDecs },
		],
	  };
	},
  data() {
    return {
		id:'',
		total:0,
		currentPage:1,
		pageSize:20,
		pagerCount:5,
		// pagercount:3,
		bannerTop:[],
		bannerMiddle:[],
		domain:this.$utils.httpUrl,
		metaName: "",
		title:"",
		metaKeywords: "",
		metaDecs: "",
		loading: false,
		post: null,
		error: null,
		keywords:'',
		hangyes:[],
		provinces:[],
		statuss:[{value:3,label:'进行中'},{value:4,label:'已结束'}],
		hangyeId: '',
		provinceId:'',
		statussId:'',
		zhaobiaolist:[],
		sandanlist:[],
		caigoulist:[],
		tableData: [],
		hangyeSearch:'',
		provinceSearch:'',
		statusSearch:''
    }
  },
  mounted() {
	this.getZhaobiao()
  },
  created() {
	this.getBanners() 
	this.getHangyes()
	this.getProvinces()
	this.getCaigou()
	this.$axios({
		url:this.$utils.httpApi + 'index/webconfig'
	}).then(res=>{
		this.title = res.data.data.webtitle
		this.metaName = '散单需求 - ' + this.title
		this.metaDecs = res.data.data.webdescription
		this.metaKeywords = res.data.data.webkeywords
	})
	// watch 路由的参数，以便再次获取数据
	this.$watch(
	// console.log('watch',this.$route.params)
	  // () => this.$route.params,
	  () => {
		if(this.hangyeSearch != ''){
			this.onHangYeChange(this.hangyeSearch)
		}else if(this.provinceSearch != ''){
			this.onProvinceChange(this.provinceSearch)
		}else if(this.statusSearch != ''){
			this.onStatusChange(this.statusSearch)
		}else if(this.keywords != ''){
			this.search(this.keywords)
		}else{
			this.getZhaobiao()
		}
	  },
	  // 组件创建完后获取数据，
	  // 此时 data 已经被 observed 了
	  // immediate: true 
	)
  },
  
  methods: {
	onHangYeChange(value){
		this.hangyeSearch = value
		this.keywords = ''
		this.provinceSearch = ''
		this.statusSearch = ''
		this.$axios({
			method: "post",//指定请求方式
			url:this.$utils.httpApi + 'search/hangye',
			data:{
				page:this.currentPage,
				typelist:1,
				keyword:value
			}
		}).then(res=>{
			this.tableData = res.data.data.zhaobiao
			this.total = res.data.data.total
		})  
	},
	onClear(){
		this.getZhaobiao()
	},
	onProvinceChange(value){
		console.log('provice',value)
		this.hangyeSearch = ''
		this.keywords = ''
		this.provinceSearch = value
		this.statusSearch = ''
		this.$axios({
			method: "post",//指定请求方式
			url:this.$utils.httpApi + 'search/province',
			data:{
				page:this.currentPage,
				typelist:1,
				keyword:value
			}
		}).then(res=>{
			this.tableData = res.data.data.zhaobiao
			this.total = res.data.data.total
		}) 
	},
	onStatusChange(value){
		console.log('Status',value)
		this.hangyeSearch = ''
		this.keywords = ''
		this.provinceSearch = ''
		this.statusSearch = value
		this.$axios({
			method: "post",//指定请求方式
			url:this.$utils.httpApi + 'search/status',
			data:{
				page:this.currentPage,
				typelist:1,
				keyword:value
			}
		}).then(res=>{
			this.tableData = res.data.data.zhaobiao
			this.total = res.data.data.total
		}) 
	},
	search(keyword){
		console.log('search',keyword)
		this.hangyeSearch = ''
		this.keywords = keyword
		this.provinceSearch = ''
		this.statusSearch = ''
		this.$axios({
			method: "post",//指定请求方式
			url:this.$utils.httpApi + 'search/search',
			data:{
				page:this.currentPage,
				typelist:1,
				keyword
			}
		}).then(res=>{
			this.tableData = res.data.data.zhaobiao
			this.total = res.data.data.total
		}) 
	},
	getHangyes(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getHangyes'
		}).then(res=>{
			this.hangyes = res.data.data
		})
	},
	getProvinces(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getProvinces'
		}).then(res=>{
			this.provinces = res.data.data
		})
	},
	getZhaobiao(){
		this.$axios({
			method: "post",//指定请求方式
			url:this.$utils.httpApi + 'index/getSandanList',
			data:{
				page:this.currentPage,
				typelist:1
			}
		}).then(res=>{
			this.sandanlist = res.data.data.sandan
			this.tableData = res.data.data.zhaobiao
			this.total = res.data.data.total
		})   
	},
	getBanners(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getBanner'
		}).then(res=>{
			res.data.data.forEach(resp=>{
				if(resp.type == 4){
					this.bannerTop.push(resp)
				}else if(resp.type == 5){
					this.bannerMiddle.push(resp)
				}
			})
		}) 
	},

	handleSizeChange(pageSize){
		 this.pagesize = pageSize
		 
	},
	currentChange(pageNum){
		this.currentPage = pageNum; 
	},
	handle(id){
		const url = '/details/id/'+id
		window.open(url, '_blank')
	},
	status(stat){
		if(stat == 2){
			return '未开始'
		}else if(stat == 3){
			return '进行中'
		}else if(stat == 4){
			return '已结束'
		}  
	},
	getCaigou(){
		this.$axios({
			url:this.$utils.httpApi + 'index/getCaigouRight'
		}).then(res=>{
			this.caigoulist = res.data.data
		})   
	},
  },
}
</script>

<style scoped>
	.red{
		color:red
	}
	.blue{
		color:#409EFF;
	}
	.text{
		cursor: pointer;
		color:#409EFF;
	}
	.el-col {
		border-radius: 4px;
	}
	.bg-purple-dark {
		background: #99a9bf;
	}
	.bg-purple {
		background: #d3dce6;
	}
	.bg-purple-light {
		background: #e5e9f2;
	}
	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}
	.search{
		margin:10px auto;
	}
	.contentList{
		margin-top: 60px;
	}
	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}
	.text {
		font-size: 14px;
	}

	.item {
		padding: 18px 0;
	}

	.box-card {
		/* width: 480px; */
	}	
	.listHeader{
		background-color: #409EFF;
		width:100%;
		height:40px;
		color:#fff;
		line-height: 40px;
		text-align: center;
		font-size: 1.1rem;
		font-weight: 700;
		margin-top: 10px;
	}
	.second{
		margin-bottom: 10px;
	}
</style>